namespace TotalContest {
    import Controller = TotalCore.Common.Controller;

    @Controller('controllers.totalcontest')
    export class RepeaterCtrl {
        public items = [];

        addItem(item = {}) {
            this.items.push(item);
        }

        deleteItem(index) {
            this.items.splice(index, 1);
        }

        moveDown(index) {
            this.moveUp(index + 1);
        }

        moveUp(index) {
            if (index === 0 || index === this.items.length) {
                return;
            }

            this.items.splice(index - 1, 0, this.items[index]);
            this.items.splice(index + 1, 1);
        }
    }

}